import React from 'react';

import { Button } from '@qality/common-components/src/atoms/Button';
import Errors from '@qality/common-components/src/atoms/Errors';
import { Header } from '@qality/common-components/src/atoms/Header';
import { PageHeader } from '@qality/common-components/src/atoms/PageHeader';

import {
  ImportSummaryButtonsContainer,
  ImportSummaryErrorsSectionStyled,
  ImportSummaryStyled,
} from './ImportSummary.styled';
import { ImportSummaryTable } from './ImportSummaryTable';

type Props = {
  importMore: () => void;
  exitImport: () => Promise<void>;
  errorMessages: Array<string>;
};

export const ImportSummaryView = ({
  importMore,
  exitImport,
  errorMessages,
}: Props): JSX.Element => {
  return (
    <ImportSummaryStyled>
      <PageHeader>Import Test Cases from CSV files</PageHeader>
      <Header spacing='medium'>Import completed</Header>
      <ImportSummaryTable />
      {!!errorMessages.length && (
        <>
          <Header spacing='medium'>Errors</Header>
          <ImportSummaryErrorsSectionStyled>
            <Errors errorMessages={errorMessages} />
          </ImportSummaryErrorsSectionStyled>
        </>
      )}
      <ImportSummaryButtonsContainer>
        <Button mr onClick={importMore}>
          Import more
        </Button>
        <Button onClick={exitImport} appearance='primary'>
          Exit importing
        </Button>
      </ImportSummaryButtonsContainer>
    </ImportSummaryStyled>
  );
};
